import React from "react";
import "../styles/Home.css";
import BookingSystem from "./BookingSystem";

const Home = () => {
    return (
        <div>

            {/* SECTION 1 */}
            <section className="home-wrapper">
                <div className="home-text">
                    <h1 className="fs" data-aos="fade-up">Where Passion Meets <br /> the Perfect Turf</h1>
                    <p className="fs1" data-aos="fade-up">“Play Hard. Play Smart. Play Here.”</p>
                    <button className="homebtn" data-aos="fade-up">Book Now</button>
                </div>
            </section>

            {/* SECTION 2 */}
            <section id="activities" className="activities" >
                <h1 className="activitiesh1" data-aos="fade-down">Our Activities</h1>
                <p className="activitiesp" data-aos="fade-down">Discover the range of sports and events you can enjoy on our premium turf facilities.</p>
                <div className="activitiessub">
                    <div className="activitiescard" data-aos="fade-up">
                        <img src="/assets/activities/football.png" alt="" />
                        <div className="activitiesicon">
                            <div className="iconimage">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640"><path d="M451 292.3C446.6 289.5 443.4 285.3 441.8 280.4C440.2 275.5 440.4 270.2 442.3 265.4L475.6 182C455.7 159.6 431 141.5 403.2 129.3L334.1 186.9C330.1 190.2 325.1 192 320 192C314.9 192 309.8 190.2 305.9 186.9L236.8 129.3C209 141.5 184.3 159.6 164.4 182L197.8 265.4C199.7 270.2 199.9 275.5 198.3 280.4C196.7 285.3 193.4 289.5 189.1 292.3L113 340.2C116 371.1 125.7 399.9 140.6 425.4L230.3 419.4C235.5 419.1 240.6 420.5 244.8 423.6C249 426.7 252 431 253.2 436.1L275.2 523.3C289.6 526.5 304.6 528.1 320 528.1C335.4 528.1 350.3 526.4 364.8 523.3L386.8 436.1C388.1 431.1 391 426.7 395.2 423.6C399.4 420.5 404.5 419.1 409.7 419.4L499.4 425.4C514.4 400 524.1 371.1 527 340.3L451 292.3zM320 64C461.4 64 576 178.6 576 320C576 461.4 461.4 576 320 576C178.6 576 64 461.4 64 320C64 178.6 178.6 64 320 64zM382 285C390.4 291.1 393.9 301.9 390.7 311.8L372.4 368.1C369.2 378 360 384.7 349.6 384.7L290.4 384.7C280 384.7 270.8 378 267.6 368.1L249.3 311.8C246.1 301.9 249.6 291.1 258 285L305.9 250.2C314.3 244.1 325.7 244.1 334.1 250.2L382 285z" /></svg>
                            </div>
                            <div className="icontext">
                                <h1>Football</h1>
                            </div>
                        </div>
                        <p>A pitch built for performance, comfort, and control.</p>
                        <ul className="cardlist">
                            <li>5-a-side & 7-a-side available</li>
                            <li>Flood lights for night games</li>
                            <li>Changing rooms & showers</li>
                        </ul>
                    </div>
                    <div className="activitiescard" data-aos="fade-up">
                        <img src="/assets/activities/cricket.png" alt="" />
                        <div className="activitiesicon">
                            <div className="iconimage">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640"><path d="M496.1 608C451.9 608 416.1 572.2 416.1 528C416.1 483.8 451.9 448 496.1 448C540.3 448 576.1 483.8 576.1 528C576.1 572.2 540.3 608 496.1 608zM504.5 32C519.6 32 534.2 37.8 545.2 48.2L592.4 93C605 105 611.5 122 609.9 139.3C608.7 152.6 602.9 165.1 593.4 174.5L395.1 373C387.8 380.3 379.4 386.4 370.1 391L238 457C228.8 461.6 220.3 467.7 213 475L121 567L122.7 568.8C130.4 578.2 129.8 592.1 121 600.9C112.2 609.7 98.3 610.2 88.9 602.6L87.1 600.9L39.1 552.9L37.4 551.1C29.7 541.7 30.3 527.8 39.1 519C47.9 510.2 61.8 509.7 71.2 517.3L73 519L165 427C172.3 419.7 178.4 411.3 183 402L249.1 269.9C253.7 260.7 259.8 252.2 267.1 244.9L462.8 49.3C473.9 38.2 488.9 32 504.5 32z" /></svg>
                            </div>
                            <div className="icontext">
                                <h1>Cricket</h1>
                            </div>
                        </div>
                        <p>Perfect bounce, smooth pitch, and bright lighting — built for true players</p>
                        <ul>
                            <li>Full & shortened pitch options</li>
                            <li>Bowling machine available</li>
                            <li>Electronic Scoreboard</li>
                        </ul>
                    </div>
                    <div className="activitiescard" data-aos="fade-up">
                        <img src="/assets/activities/training.png" alt="" />
                        <div className="activitiesicon">
                            <div className="iconimage">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640"><path d="M192 144C222.9 144 248 118.9 248 88C248 57.1 222.9 32 192 32C161.1 32 136 57.1 136 88C136 118.9 161.1 144 192 144zM176 576L176 416C176 407.2 183.2 400 192 400C200.8 400 208 407.2 208 416L208 576C208 593.7 222.3 608 240 608C257.7 608 272 593.7 272 576L272 240L400 240C417.7 240 432 225.7 432 208C432 190.3 417.7 176 400 176L384 176L384 128L576 128L576 320L384 320L384 288L320 288L320 336C320 362.5 341.5 384 368 384L592 384C618.5 384 640 362.5 640 336L640 112C640 85.5 618.5 64 592 64L368 64C341.5 64 320 85.5 320 112L320 176L197.3 176C151.7 176 108.8 197.6 81.7 234.2L14.3 324.9C3.8 339.1 6.7 359.1 20.9 369.7C35.1 380.3 55.1 377.3 65.7 363.1L112 300.7L112 576C112 593.7 126.3 608 144 608C161.7 608 176 593.7 176 576z" /></svg>
                            </div>
                            <div className="icontext">
                                <h1>Training</h1>
                            </div>
                        </div>
                        <p>Boost your skills, sharpen your mind! Join our interactive training sessions</p>
                        <ul>
                            <li>Our certified coaches</li>
                            <li>groups of all skill levels</li>
                            <li>Flexible timing sessions</li>
                        </ul>
                    </div>
                </div>
            </section>

            {/* SECTION 3 */}
            <section className="activities" >
                <h1 className="activitiesh1" data-aos="fade-down">Our Turf Highlights</h1>
                <p className="activitiesp" data-aos="fade-down">Experience top-quality turf with pro lighting, clean pitch, and full maintenance</p>
                <div className="activitiessub">
                    <div className="activitiescard" data-aos="fade-up">
                        <img src="/assets/lighting/lighting.png" alt="" />
                        <div className="activitiesicon">
                            <div className="iconimage">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640"><path d="M424.5 355.1C449 329.2 464 294.4 464 256C464 176.5 399.5 112 320 112C240.5 112 176 176.5 176 256C176 294.4 191 329.2 215.5 355.1C236.8 377.5 260.4 409.1 268.8 448L371.2 448C379.6 409 403.2 377.5 424.5 355.1zM459.3 388.1C435.7 413 416 443.4 416 477.7L416 496C416 540.2 380.2 576 336 576L304 576C259.8 576 224 540.2 224 496L224 477.7C224 443.4 204.3 413 180.7 388.1C148 353.7 128 307.2 128 256C128 150 214 64 320 64C426 64 512 150 512 256C512 307.2 492 353.7 459.3 388.1zM272 248C272 261.3 261.3 272 248 272C234.7 272 224 261.3 224 248C224 199.4 263.4 160 312 160C325.3 160 336 170.7 336 184C336 197.3 325.3 208 312 208C289.9 208 272 225.9 272 248z" /></svg>
                            </div>
                            <div className="icontext">
                                <h1>Premium lighting</h1>
                            </div>
                        </div>
                        <p>Professional LED floodlights
                            ensuring perfect visibility for night games</p>
                        <ul className="cardlist">
                            <li>High-intensity LED</li>
                            <li>Even Coverage</li>
                            <li>Night play enabled  </li>
                        </ul>
                    </div>
                    <div className="activitiescard" data-aos="fade-up">
                        <img src="/assets/lighting/hall.png" alt="" />
                        <div className="activitiesicon">
                            <div className="iconimage">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640"><path d="M300.9 149.2L184.3 278.8C179.7 283.9 179.9 291.8 184.8 296.7C215.3 327.2 264.8 327.2 295.3 296.7L327.1 264.9C331.3 260.7 336.6 258.4 342 258C348.8 257.4 355.8 259.7 361 264.9L537.6 440L608 384L608 96L496 160L472.2 144.1C456.4 133.6 437.9 128 418.9 128L348.5 128C347.4 128 346.2 128 345.1 128.1C328.2 129 312.3 136.6 300.9 149.2zM148.6 246.7L255.4 128L215.8 128C190.3 128 165.9 138.1 147.9 156.1L144 160L32 96L32 384L188.4 514.3C211.4 533.5 240.4 544 270.3 544L286 544L279 537C269.6 527.6 269.6 512.4 279 503.1C288.4 493.8 303.6 493.7 312.9 503.1L353.9 544.1L362.9 544.1C382 544.1 400.7 539.8 417.7 531.8L391 505C381.6 495.6 381.6 480.4 391 471.1C400.4 461.8 415.6 461.7 424.9 471.1L456.9 503.1L474.4 485.6C483.3 476.7 485.9 463.8 482 452.5L344.1 315.7L329.2 330.6C279.9 379.9 200.1 379.9 150.8 330.6C127.8 307.6 126.9 270.7 148.6 246.6z" /></svg>
                            </div>
                            <div className="icontext">
                                <h1>Waiting Hall</h1>
                            </div>
                        </div>
                        <p>Comfortable lounge area with modern
                            seating and amenities</p>
                        <ul>
                            <li>Air-conditioned</li>
                            <li>Refreshments</li>
                            <li>Lockers Available</li>
                        </ul>
                    </div>
                    <div className="activitiescard" data-aos="fade-up">
                        <img src="/assets/lighting/audience.png" alt="" />
                        <div className="activitiesicon">
                            <div className="iconimage">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640"><path d="M96 192C96 130.1 146.1 80 208 80C269.9 80 320 130.1 320 192C320 253.9 269.9 304 208 304C146.1 304 96 253.9 96 192zM32 528C32 430.8 110.8 352 208 352C305.2 352 384 430.8 384 528L384 534C384 557.2 365.2 576 342 576L74 576C50.8 576 32 557.2 32 534L32 528zM464 128C517 128 560 171 560 224C560 277 517 320 464 320C411 320 368 277 368 224C368 171 411 128 464 128zM464 368C543.5 368 608 432.5 608 512L608 534.4C608 557.4 589.4 576 566.4 576L421.6 576C428.2 563.5 432 549.2 432 534L432 528C432 476.5 414.6 429.1 385.5 391.3C408.1 376.6 435.1 368 464 368z" /></svg>
                            </div>
                            <div className="icontext">
                                <h1>Audience Space</h1>
                            </div>
                        </div>
                        <p>Dedicated seating for spectators with excellent viewing angles</p>
                        <ul>
                            <li>Comfortable seating</li>
                            <li>Clear views</li>
                            <li>Event-ready</li>
                        </ul>
                    </div>
                </div>
            </section>

            {/* SECTION 6 */}
            <section id="bookings" className="bookings">
                <BookingSystem />
            </section>

            {/* SECTION 4 */}
            <section className="events">
                <h1 className="activitiesh1 eventh1" data-aos="fade-down">Upcoming Events</h1>
                <div className="eventparent">
                    <div className="subevent" data-aos="fade-up">
                        <img src="/assets/event/event1.png" alt="" />
                        <div className="eventdes">
                            <h2 className="eventh2">Weekend Cricket Tournament</h2>
                            <p className="eventp">A 2-day cricket tournament featuring 8 local teams competing for the Green Play Trophy and cash prizes.</p>
                            <ul className="eventul">
                                <li>June 24-25, 2023</li>
                                <li>9:00 AM - 6:00 PM</li>
                                <li>Main Cricket Ground</li>
                            </ul>
                            <button className="regbtn">Register</button>
                        </div>
                    </div>
                    <div className="subevent" data-aos="fade-up">
                        <img src="/assets/event/event2.png" alt="" />
                        <div className="eventdes">
                            <h2 className="eventh2">Corporate Football League</h2>
                            <p className="eventp">A month-long football league for corporate teams to compete and build team spirit. Registration open for companies.</p>
                            <ul className="eventul">
                                <li>July 10-31, 2023</li>
                                <li>6:00 PM - 10:00 PM (Weekdays)</li>
                                <li>Football Arena</li>
                            </ul>
                            <button className="regbtn">Register</button>
                        </div>
                    </div>
                    <div className="subevent" data-aos="fade-up">
                        <img src="/assets/event/event3.png" alt="" />
                        <div className="eventdes">
                            <h2 className="eventh2">Kids Summer Sports Camp</h2>
                            <p className="eventp">A month-long summer camp for children aged 8-14 to learn cricket and football fundamentals from professional coaches.</p>
                            <ul className="eventul">
                                <li>May 15 - June 15, 2023</li>
                                <li>8:00 AM - 12:00 PM</li>
                                <li>Training Ground</li>
                            </ul>
                            <button className="regbtn">Register</button>
                        </div>
                    </div>
                    <div className="subevent" data-aos="fade-up">
                        <img src="/assets/event/event4.png" alt="" />
                        <div className="eventdes">
                            <h2 className="eventh2">GTL Cricket Tournament</h2>
                            <p className="eventp">A 2-day cricket tournament featuring 8 local teams competing for the Green Play Trophy and cash prizes.</p>
                            <ul className="eventul">
                                <li>November-25, 2023</li>
                                <li>9:00 AM</li>
                                <li>Main Cricket Ground</li>
                            </ul>
                            <button className="regbtn">Register</button>
                        </div>
                    </div>
                </div>
            </section>

            {/* SECTION 5 */}
            <section className="events">
                <h1 className="activitiesh1" data-aos="fade-down">What Our Customers Say</h1>
                <p className="activitiesp" data-aos="fade-down">Dont just take our word for it. Here's what sports enthusiasts and event organizers have to say about our turf</p>
                <div className="reviewmain" data-aos="fade-up">
                    <div className="reviewcard">
                        <div className="propar">
                            <div className="profileimg"></div>
                            <div className="profilename">
                                <h2 className="profileh2">Michael Johnson</h2>
                                <p className="profilep">Football Coach</p>
                            </div>
                        </div>
                        <img className="imgstar" src="/assets/star/star1.png" alt="" />
                        <p className="starp">"The turf quality is exceptional. My team loves practicing here as it provides the perfect surface for our training sessions."</p>
                    </div>
                    <div className="reviewcard">
                        <div className="propar">
                            <div className="profileimg"></div>
                            <div className="profilename">
                                <h2 className="profileh2">Sarah Williams</h2>
                                <p className="profilep">Corporate Event Manager</p>
                            </div>
                        </div>
                        <img className="imgstar" src="/assets/star/star1.png" alt="" />
                        <p className="starp">"We hosted our company sports day here and everything was perfect. The staff was extremely helpful and the facilities are top-notch." </p>
                    </div>
                    <div className="reviewcard">
                        <div className="propar">
                            <div className="profileimg"></div>
                            <div className="profilename">
                                <h2 className="profileh2">David Chen</h2>
                                <p className="profilep">Cricket Team Captain</p>
                            </div>
                        </div>
                        <img className="imgstar" src="/assets/star/star2.png" alt="" />
                        <p className="starp">"The cricket pitch is one of the best I've played on. The bounce is consistent and the overall maintenance is excellent." </p>
                    </div>
                </div>
            </section>

            {/* SECTION 7 */}
            <section className="accordion-wrapper">
                <h1 className="activitiesh1 accord" data-aos="fade-down">Frequently Asked Questions</h1>

                <details className="accordion" name="my-accordion" data-aos="fade-up">
                    <summary className="accordion-summary">Are there any restrictions on footwear?</summary>
                    <p className="accordion-content">
                        Yes, we recommend using turf shoes or flat-soled sports shoes. Metal studs and spikes are not permitted as they can damage the artificial turf surface.
                    </p>
                </details>

                <details className="accordion" name="my-accordion" data-aos="fade-up">
                    <summary className="accordion-summary">Can we bring our own equipment?</summary>
                    <p className="accordion-content">
                        Absolutely! While we provide basic equipment, you're welcome to bring your own cricket bats, balls, or other sports gear. We do ask that you avoid using equipment that might damage the turf.
                    </p>
                </details>

                <details className="accordion" name="my-accordion" data-aos="fade-up">
                    <summary className="accordion-summary">Is there parking available at the facility?</summary>
                    <p className="accordion-content">
                        Yes, we have a dedicated parking area that can accommodate up to 30 vehicles. Additional street parking is also available nearby.
                    </p>
                </details>

                <details className="accordion" name="my-accordion" data-aos="fade-up">
                    <summary className="accordion-summary">Do you provide coaching services?</summary>
                    <p className="accordion-content">
                        We have partnerships with professional coaches for both cricket and football. Coaching sessions can be booked separately through our contact page or at the reception desk.
                    </p>
                </details>
            </section>
        </div>
    );
};

export default Home;
